"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.exportToExcelZip = exports.exportToExcel = exports.writeWorksheet = exports.updateFileInfoRows = void 0;
/* eslint-disable no-undef */
var BaseFile_1 = require("@cck/common/dist/data/BaseFile");
var Staff_1 = require("@cck/common/dist/data/Staff");
var Translation_1 = require("@cck/common/dist/data/Translation");
var StringUtils_1 = require("@cck/common/dist/utils/StringUtils");
var TimeUtils_1 = require("@cck/common/dist/utils/TimeUtils");
var ExcelJS = __importStar(require("exceljs"));
var file_saver_1 = require("file-saver");
var jszip_1 = __importDefault(require("jszip"));
var lodash_1 = __importDefault(require("lodash"));
var StorageManager_1 = require("../storage/StorageManager");
var MENU_STYLE = {
    style: { font: { bold: true } },
    fill: {
        type: 'pattern',
        pattern: 'solid',
        fgColor: {
            argb: 'FFF2F2F2' // RGB(242, 242, 242)
        }
    },
    alignment: { horizontal: 'left', vertical: 'middle' }
};
var CENTER_MENU_STYLE = __assign(__assign({}, MENU_STYLE), { alignment: { horizontal: 'center', vertical: 'middle' } });
var BORDER = {
    top: { style: 'thin', color: { argb: 'FF808080' } },
    left: { style: 'thin', color: { argb: 'FF808080' } },
    bottom: { style: 'thin', color: { argb: 'FF808080' } },
    right: { style: 'thin', color: { argb: 'FF808080' } }
};
function getCellId(cellIndex, rowIndex) {
    return "".concat((0, StringUtils_1.toLetters)(cellIndex + 1)).concat(rowIndex + 1);
}
function getOperationEvaluationDefs(staffs) {
    return {
        TestInfo: {
            columnSize: [19],
            mergedCells: ['A1:E1', 'B2:E2', 'B3:E3', 'B4:E4', 'B5:E5', 'B6:E6', 'B7:E7'],
            rows: [
                [
                    __assign({ value: 'Test Info' }, CENTER_MENU_STYLE)
                ],
                [__assign({ value: (0, Translation_1.getKoName)('control', 'number') }, MENU_STYLE), { key: 'controlId' }],
                [__assign({ value: (0, Translation_1.getKoName)('control', 'period') }, MENU_STYLE), { key: 'base.period' }],
                [
                    __assign({ value: (0, Translation_1.getKoName)('control', 'inchargeInRCM') }, MENU_STYLE),
                    { key: 'content.control.incharge', formatter: (0, Staff_1.StaffFormatValue)(staffs) }
                ],
                [
                    __assign({ value: (0, Translation_1.getKoName)('control', 'ownerInRCM') }, MENU_STYLE),
                    { key: 'content.control.owner', formatter: (0, Staff_1.StaffFormatValue)(staffs) }
                ],
                [
                    __assign({ value: (0, Translation_1.getKoName)('control', 'createDate') }, MENU_STYLE),
                    {
                        key: 'content.data.createDate',
                        formatter: function (dateStr) { return (0, TimeUtils_1.parseDateStr)('YYYY-MM-DD', dateStr); }
                    }
                ],
                [
                    __assign({ value: (0, Translation_1.getKoName)('control', 'updateTime') }, MENU_STYLE),
                    { key: 'content.data.updateTime', formatter: TimeUtils_1.parseTimeStr }
                ]
            ]
        },
        FileInfo: {
            columnSize: [85, 28, 28, 28],
            mergedCells: [],
            rows: [
                [
                    __assign({ value: (0, Translation_1.getKoName)('common', 'fileName') }, CENTER_MENU_STYLE),
                    __assign({ value: (0, Translation_1.getKoName)('common', 'type') }, CENTER_MENU_STYLE),
                    __assign({ value: (0, Translation_1.getKoName)('common', 'updater') }, CENTER_MENU_STYLE),
                    __assign({ value: (0, Translation_1.getKoName)('common', 'updateTime') }, CENTER_MENU_STYLE)
                ]
            ]
        },
        PopulationInfo: {
            defaultColWidth: 13,
            columnSize: [21],
            rowHeight: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 8],
            mergedCells: ['A1:J1', 'B2:J2', 'B3:J3', 'B4:J4', 'B5:J5', 'B6:J6', 'B7:J7', 'A10:J10'],
            rows: [
                [
                    __assign({ value: '모집단 정보' }, CENTER_MENU_STYLE)
                ],
                [
                    __assign({ value: (0, Translation_1.getKoName)('control', 'populationDescription') }, MENU_STYLE),
                    { key: 'content.data.populationDescription' }
                ],
                [
                    __assign({ value: (0, Translation_1.getKoName)('control', 'populationCount') }, MENU_STYLE),
                    { key: 'content.data.populationCount' }
                ],
                [
                    __assign({ value: (0, Translation_1.getKoName)('control', 'populationCompleteness') }, MENU_STYLE),
                    { key: 'content.data.populationCompleteness' }
                ],
                [
                    __assign({ value: (0, Translation_1.getKoName)('control', 'samplingMethod') }, MENU_STYLE),
                    { key: 'content.data.samplingMethod' }
                ],
                [
                    __assign({ value: "".concat((0, Translation_1.getKoName)('control', 'samplingCount'), "(\uD589)") }, MENU_STYLE),
                    { key: 'content.data.samplingCount' }
                ],
                [
                    __assign({ value: "".concat((0, Translation_1.getKoName)('control', 'samplingAttributeCount'), "(\uC5F4)") }, MENU_STYLE),
                    { key: 'content.data.populationTableColumnCount' }
                ],
                [],
                [],
                [
                    __assign({ value: '샘플링 결과' }, CENTER_MENU_STYLE)
                ],
                []
            ]
        },
        TestContentsInfo: {
            defaultColWidth: 11,
            columnSize: [21],
            mergedCells: ['A1:J1', 'B2:J2'],
            rows: [
                [
                    __assign({ value: '테스트 수행 기준' }, CENTER_MENU_STYLE)
                ],
                [
                    __assign({ value: (0, Translation_1.getKoName)('control', 'samplingAttributeCount') }, MENU_STYLE),
                    {
                        key: 'content.data.samplingAttributeCount'
                    }
                ],
                [],
                [],
                [],
                [
                    __assign({ value: '테스트 수행 내역' }, CENTER_MENU_STYLE)
                ],
                [],
                [],
                [],
                [
                    __assign({ value: '결과 정리' }, CENTER_MENU_STYLE)
                ],
                [
                    __assign({ value: (0, Translation_1.getKoName)('control', 'populationCount') }, MENU_STYLE),
                    { key: 'content.data.populationCount' }
                ],
                [
                    __assign({ value: (0, Translation_1.getKoName)('control', 'samplingCount') }, MENU_STYLE),
                    { key: 'content.data.samplingCount' }
                ],
                [
                    __assign({ value: (0, Translation_1.getKoName)('control', 'validCount') }, MENU_STYLE),
                    { key: 'content.data.validCount' }
                ],
                [
                    __assign({ value: (0, Translation_1.getKoName)('control', 'invalidCount') }, MENU_STYLE),
                    { key: 'content.data.invalidCount' }
                ],
                [
                    __assign({ value: (0, Translation_1.getKoName)('control', 'testResult') }, MENU_STYLE),
                    { key: 'content.data.testResult' }
                ]
            ]
        }
    };
}
function addFileInfoRow(staffs, fileInfoDefs, fileInfo) {
    if (fileInfo && !lodash_1.default.isEmpty(fileInfo.name) && fileInfo.state === BaseFile_1.FileState.OK) {
        fileInfoDefs.rows.push([
            { value: fileInfo.name },
            { value: fileInfo.type },
            { value: (0, Staff_1.StaffFormatValue)(staffs)(fileInfo.updater) },
            { value: (0, TimeUtils_1.parseTimeStr)(fileInfo.updateTime) }
        ]);
    }
}
function updateFileInfoRows(staffs, fileInfoDefs, evaluation) {
    var newFileInfoDefs = lodash_1.default.cloneDeep(fileInfoDefs);
    addFileInfoRow(staffs, newFileInfoDefs, evaluation.content.files.record);
    addFileInfoRow(staffs, newFileInfoDefs, evaluation.content.files.population);
    lodash_1.default.forEach(evaluation.content.files.evidence, function (evidenceFile) {
        addFileInfoRow(staffs, newFileInfoDefs, evidenceFile);
    });
    lodash_1.default.forEach(evaluation.content.files.extra, function (extraFile) {
        addFileInfoRow(staffs, newFileInfoDefs, extraFile);
    });
    return newFileInfoDefs;
}
exports.updateFileInfoRows = updateFileInfoRows;
function convertTable(tableContent) {
    return __spreadArray([
        lodash_1.default.map(tableContent.headerRow, function (headerRow) {
            return __assign({ value: headerRow }, CENTER_MENU_STYLE);
        })
    ], lodash_1.default.map(tableContent.rowObjectList, function (rowObject) {
        return lodash_1.default.map(tableContent.headerRow, function (headerRow, index) { return (__assign({ value: lodash_1.default.get(rowObject, headerRow, '') }, (index === 0 && CENTER_MENU_STYLE))); });
    }), true);
}
function updateSamplingResults(populationInfoDefs, evaluation) {
    var _a;
    var samplingResult = lodash_1.default.get(evaluation, 'content.data.samplingResult');
    if (!samplingResult) {
        return populationInfoDefs;
    }
    var newPopulationInfoDefs = lodash_1.default.cloneDeep(populationInfoDefs);
    (_a = newPopulationInfoDefs.rows).push.apply(_a, convertTable(samplingResult));
    return newPopulationInfoDefs;
}
function updateTestContents(testContentInfoDefs, evaluation) {
    var _a, _b;
    var newTestContentInfoDefs = lodash_1.default.cloneDeep(testContentInfoDefs);
    var rowIndex = 3;
    var attributeContentRows = convertTable(lodash_1.default.get(evaluation, 'content.data.attributeContents'));
    if (attributeContentRows && !lodash_1.default.isEmpty(lodash_1.default.head(attributeContentRows))) {
        if (lodash_1.default.get(lodash_1.default.head(lodash_1.default.head(attributeContentRows)), 'value') === 'Attribute') {
            attributeContentRows[0][0].value = '속성 번호';
        }
        for (var i = 0; i < attributeContentRows.length; ++i) {
            newTestContentInfoDefs.mergedCells.push("".concat(getCellId(1, rowIndex + i), ":").concat(getCellId(4, rowIndex + i)));
            newTestContentInfoDefs.mergedCells.push("".concat(getCellId(5, rowIndex + i), ":").concat(getCellId(8, rowIndex + i)));
            attributeContentRows[i].splice(3, 0, {}, {}, {});
            attributeContentRows[i].splice(2, 0, {}, {}, {});
        }
        (_a = newTestContentInfoDefs.rows).splice.apply(_a, __spreadArray([rowIndex, 0], attributeContentRows, false));
        rowIndex += attributeContentRows.length;
    }
    rowIndex += 4;
    newTestContentInfoDefs.mergedCells.push("".concat(getCellId(0, rowIndex - 2), ":").concat(getCellId(9, rowIndex - 2)));
    var testContentRows = convertTable(lodash_1.default.get(evaluation, 'content.data.testContents'));
    var subHeaders = [];
    if (testContentRows && lodash_1.default.head(testContentRows)) {
        var headers = lodash_1.default.head(testContentRows);
        var resultRe = /^Attribute_(\d+)\/결과$/;
        var detailRe = /^Attribute_(\d+)\/상세$/;
        for (var index = headers.length - 1; index >= 0; --index) {
            var header = headers[index];
            if (lodash_1.default.get(header, 'value') === 'No') {
                header.value = '항목 번호';
            }
            var matched = resultRe.exec(header.value);
            if (matched && matched.length > 1) {
                header.value = "\uC18D\uC131 \uBC88\uD638 ".concat(matched[1]);
                subHeaders.push(__assign({ value: '결과' }, CENTER_MENU_STYLE));
            }
            else if (detailRe.exec(header.value)) {
                headers.splice(index, 1, {}, {}, {});
                subHeaders.push.apply(subHeaders, [{}, {}, __assign({ value: '상세' }, CENTER_MENU_STYLE)]);
                for (var j = 1; j < testContentRows.length; ++j) {
                    testContentRows[j].splice(index + 1, 0, {}, {});
                }
            }
            else {
                subHeaders.push({ value: '' });
            }
        }
        testContentRows.splice(1, 0, lodash_1.default.reverse(subHeaders));
        // For 항목번호/테스트 결과/증빙자료 Ref
        lodash_1.default.forEach([0, headers.length - 2, headers.length - 1], function (colIdx) {
            if (colIdx >= 0) {
                newTestContentInfoDefs.mergedCells.push("".concat(getCellId(colIdx, rowIndex), ":").concat(getCellId(colIdx, rowIndex + 1)));
            }
        });
        // For 속성 상세
        for (var i = 0; i < testContentRows.length; ++i) {
            var prevColumnIndex = 0;
            for (var j = 0; j < testContentRows[i].length; ++j) {
                if (lodash_1.default.has(testContentRows[i][j], 'value')) {
                    if (j - prevColumnIndex > 1) {
                        newTestContentInfoDefs.mergedCells.push("".concat(getCellId(prevColumnIndex, rowIndex + i), ":").concat(getCellId(j - 1, rowIndex + i)));
                    }
                    prevColumnIndex = j;
                }
            }
        }
    }
    (_b = newTestContentInfoDefs.rows).splice.apply(_b, __spreadArray([rowIndex, 0], testContentRows, false));
    rowIndex += testContentRows.length + 2;
    newTestContentInfoDefs.mergedCells.push("".concat(getCellId(0, rowIndex), ":").concat(getCellId(9, rowIndex)));
    for (var i = 1; i <= 5; ++i) {
        newTestContentInfoDefs.mergedCells.push("".concat(getCellId(1, rowIndex + i), ":").concat(getCellId(9, rowIndex + i)));
    }
    return newTestContentInfoDefs;
}
function writeWorksheet(sheetDef, worksheet, evaluation) {
    if (lodash_1.default.has(sheetDef, 'defaultColWidth')) {
        worksheet.properties.defaultColWidth = sheetDef.defaultColWidth;
    }
    lodash_1.default.forEach(sheetDef.rows, function (rowDef, rowIndex) {
        lodash_1.default.forEach(rowDef, function (cellDef, cellIndex) {
            var cell = worksheet.getCell(getCellId(cellIndex, rowIndex));
            if (cellDef.value) {
                cell.value = cellDef.value;
            }
            if (cellDef.key) {
                if (cellDef.formatter) {
                    cell.value = cellDef.formatter(lodash_1.default.get(evaluation, cellDef.key));
                }
                else {
                    cell.value = lodash_1.default.get(evaluation, cellDef.key, '').toString();
                }
            }
            if (cellDef.style) {
                cell.style = lodash_1.default.cloneDeep(cellDef.style);
            }
            if (cellDef.fill) {
                cell.fill = lodash_1.default.cloneDeep(cellDef.fill);
            }
            if (cellDef.alignment) {
                cell.alignment = lodash_1.default.cloneDeep(cellDef.alignment);
                cell.alignment.wrapText = true;
            }
            else {
                cell.alignment = { wrapText: true };
            }
            if (cellIndex === 0 && lodash_1.default.isEmpty(cell.value)) {
                return;
            }
            cell.border = BORDER;
        });
    });
    if (lodash_1.default.has(sheetDef, 'mergedCells')) {
        lodash_1.default.forEach(sheetDef.mergedCells, function (mergedCell) {
            worksheet.mergeCells(mergedCell);
        });
    }
    if (lodash_1.default.has(sheetDef, 'columnSize')) {
        lodash_1.default.forEach(sheetDef.columnSize, function (columnSize, index) {
            worksheet.getColumn(index + 1).width = columnSize;
        });
    }
    if (lodash_1.default.has(sheetDef, 'rowHeight')) {
        lodash_1.default.forEach(sheetDef.rowHeight, function (rowHeight, index) {
            if (rowHeight <= 0) {
                return;
            }
            worksheet.getRow(index + 1).height = rowHeight;
        });
    }
    if (lodash_1.default.has(sheetDef, 'rowHeightMap')) {
        lodash_1.default.map(sheetDef.rowHeightMap, function (newRowHeight, rowIndex) {
            worksheet.getRow(lodash_1.default.isNumber(rowIndex) ? rowIndex : lodash_1.default.toNumber(rowIndex)).height = newRowHeight;
        });
    }
}
exports.writeWorksheet = writeWorksheet;
function exportToExcel(staffs, evaluation) {
    return __awaiter(this, void 0, void 0, function () {
        var workbook, evaluationDefs, sheetOptions, testInfoSheet, fileInfoSheet, populationInfoSheet, testContentsInfoSheet, buffer, fileType;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    workbook = new ExcelJS.Workbook();
                    workbook.creator = 'CCKSolution';
                    evaluationDefs = getOperationEvaluationDefs(staffs);
                    sheetOptions = { views: [{ showGridLines: false, zoomScale: 85 }] };
                    testInfoSheet = workbook.addWorksheet('1_테스트개요', sheetOptions);
                    writeWorksheet(evaluationDefs.TestInfo, testInfoSheet, evaluation);
                    fileInfoSheet = workbook.addWorksheet('2_파일정보', sheetOptions);
                    writeWorksheet(updateFileInfoRows(staffs, evaluationDefs.FileInfo, evaluation), fileInfoSheet, evaluation);
                    populationInfoSheet = workbook.addWorksheet('3_모집단정보 및 샘플링내역', sheetOptions);
                    writeWorksheet(updateSamplingResults(evaluationDefs.PopulationInfo, evaluation), populationInfoSheet, evaluation);
                    testContentsInfoSheet = workbook.addWorksheet('4_테스트수행 및 결과', sheetOptions);
                    writeWorksheet(updateTestContents(evaluationDefs.TestContentsInfo, evaluation), testContentsInfoSheet, evaluation);
                    return [4 /*yield*/, workbook.xlsx.writeBuffer()];
                case 1:
                    buffer = _a.sent();
                    fileType = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet';
                    return [2 /*return*/, new Blob([buffer], { type: fileType })];
            }
        });
    });
}
exports.exportToExcel = exportToExcel;
function downloadFilesWithoutRecord(zip, evaluation) {
    return __awaiter(this, void 0, void 0, function () {
        var baseFilePath, files, filePath, fileBlob;
        var _this = this;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    baseFilePath = "\uC6B4\uC601\uD3C9\uAC00/".concat(evaluation.base.name, "/").concat(evaluation.controlId);
                    files = evaluation.content.files;
                    if (!(files.population && !lodash_1.default.isEmpty(files.population.name))) return [3 /*break*/, 2];
                    filePath = "".concat(baseFilePath, "/").concat(files.population.name);
                    return [4 /*yield*/, (0, StorageManager_1.downloadBlobFromPath)(filePath)];
                case 1:
                    fileBlob = _a.sent();
                    zip.file(files.population.name, fileBlob, { binary: true });
                    _a.label = 2;
                case 2: return [4 /*yield*/, Promise.all(lodash_1.default.map(lodash_1.default.concat(lodash_1.default.values(files.evidence), lodash_1.default.values(files.extra)), function (file) { return __awaiter(_this, void 0, void 0, function () {
                        var filePath, fileBlob;
                        return __generator(this, function (_a) {
                            switch (_a.label) {
                                case 0:
                                    filePath = "".concat(baseFilePath, "/").concat(file === null || file === void 0 ? void 0 : file.name);
                                    return [4 /*yield*/, (0, StorageManager_1.downloadBlobFromPath)(filePath)];
                                case 1:
                                    fileBlob = _a.sent();
                                    zip.file(file === null || file === void 0 ? void 0 : file.name, fileBlob, { binary: true });
                                    return [2 /*return*/];
                            }
                        });
                    }); }))];
                case 3:
                    _a.sent();
                    return [2 /*return*/];
            }
        });
    });
}
function exportToExcelZip(staffs, evaluations) {
    return __awaiter(this, void 0, void 0, function () {
        var zip;
        var _this = this;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    zip = new jszip_1.default();
                    return [4 /*yield*/, Promise.all(lodash_1.default.map(evaluations, function (evaluation) { return __awaiter(_this, void 0, void 0, function () {
                            var subZip;
                            return __generator(this, function (_a) {
                                switch (_a.label) {
                                    case 0:
                                        subZip = zip.folder(evaluation.controlId);
                                        if (!subZip) return [3 /*break*/, 2];
                                        subZip.file("(".concat(evaluation.base.name, ")(").concat(evaluation.controlId, ")(\uBCF4\uACE0\uC11C readonly) \uBCF4\uACE0\uC11C.xlsx"), exportToExcel(staffs, evaluation), {
                                            binary: true
                                        });
                                        return [4 /*yield*/, downloadFilesWithoutRecord(subZip, evaluation)];
                                    case 1:
                                        _a.sent();
                                        _a.label = 2;
                                    case 2: return [2 /*return*/];
                                }
                            });
                        }); }))];
                case 1:
                    _a.sent();
                    zip.generateAsync({ type: 'blob' }).then(function (content) {
                        var name = lodash_1.default.get(lodash_1.default.head(evaluations), 'base.name', '운영평가');
                        (0, file_saver_1.saveAs)(content, "".concat(name, "_\uBCF4\uACE0\uC11C.zip"));
                    });
                    return [2 /*return*/];
            }
        });
    });
}
exports.exportToExcelZip = exportToExcelZip;
//# sourceMappingURL=ExcelExporter.js.map